import React, { useRef, useState } from "react";
import GeneralModal from "../CommonComponents/generalModal";
import { useSelector } from "react-redux";

const ReferralLinkModal = () => {
    const clipBoardText = useRef(null);
    const referralLink = useSelector((state) => state.referralLink);
    const [isCopied, setIsCopied] = useState(false);

    if (referralLink == null) return <></>;

    const copyToClipBoard = () => {
        navigator.clipboard.writeText(referralLink);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    };

    return (
        <div className="col-6 text-end">
            <GeneralModal
                title={"Referral Link"}
                modalId={"referralLinkShareModal"}
                btnText={"+ Add Accounts"}
                showFooterBtn={false}>
                <div className="pt-4">
                    <div className="referral-text">
                        Users that create a new Shipday account with this link will be automatically added to your partner dashboard.
                    </div>
                    <div className="referral-link-container">
                        <div className="referral-link-box">{referralLink}</div>
                        <div
                            onClick={copyToClipBoard}
                            className="referral-copy-btn"
                            title={"Copy Link"}>
                            {!isCopied && <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-copy"
                                viewBox="0 0 16 16">
                                <path
                                    fillRule="evenodd"
                                    d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"
                                />
                            </svg>}
                            {isCopied &&
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                     className="bi bi-check2" viewBox="0 0 16 16">
                                    <path
                                        d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                </svg>
                            }
                        </div>
                        <a
                            href={referralLink}
                            target="_blank"
                            rel="noreferrer"
                            className="referral-create-btn sd-primary-btn">
                            <span ref={clipBoardText}>Create Account</span>
                        </a>
                    </div>
                </div>
            </GeneralModal>
        </div>
    );
};

export default ReferralLinkModal;
